<div class="download-loading">
  <div class="download-loading__header">
    <h3 class="download-loading__title">Quote PDF</h3>
    <button
      type="button"
      class="download-loading__close"
      (click)="close()"
      aria-label="Close dialog"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M6.36436 19.0588L4.96436 17.6588L10.5644 12.0588L4.96436 6.45884L6.36436 5.05884L11.9644 10.6588L17.5644 5.05884L18.9644 6.45884L13.3644 12.0588L18.9644 17.6588L17.5644 19.0588L11.9644 13.4588L6.36436 19.0588Z"
          fill="white"
        />
      </svg>
    </button>
  </div>

  <div class="download-loading__body">
    <app-spinner [display]="true" [diameter]="80"></app-spinner>
    <p class="download-loading__text">Generating Quote PDF...</p>
  </div>
</div>
